import React from "react"

const Confetti = props => {
  return (
    <svg
      width="551"
      height="320"
      viewBox="0 0 551 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M89.5 192.163C89.5 195.728 86.596 198.628 83 198.628C79.404 198.628 76.5 195.728 76.5 192.163C76.5 188.599 79.404 185.698 83 185.698C86.596 185.698 89.5 188.599 89.5 192.163Z"
        stroke="#FF8255"
        strokeWidth="3"
      />
      <path
        d="M450.5 80.6489C450.5 84.2134 447.596 87.1142 444 87.1142C440.404 87.1142 437.5 84.2134 437.5 80.6489C437.5 77.0843 440.404 74.1836 444 74.1836C447.596 74.1836 450.5 77.0843 450.5 80.6489Z"
        stroke="#25B5F3"
        strokeWidth="3"
      />
      <path
        d="M7.25 152.337C7.25 154.119 5.798 155.569 4 155.569C2.202 155.569 0.75 154.119 0.75 152.337C0.75 150.554 2.202 149.104 4 149.104C5.798 149.104 7.25 150.554 7.25 152.337Z"
        stroke="#8453E6"
        strokeWidth="1.5"
      />
      <path
        d="M248.25 314.63C248.25 316.412 246.798 317.862 245 317.862C243.202 317.862 241.75 316.412 241.75 314.63C241.75 312.847 243.202 311.397 245 311.397C246.798 311.397 248.25 312.847 248.25 314.63Z"
        stroke="#FF8255"
        strokeWidth="1.5"
      />
      <path
        d="M311.25 4.97826C311.25 6.76053 309.798 8.21091 308 8.21091C306.202 8.21091 304.75 6.76053 304.75 4.97826C304.75 3.19598 306.202 1.74561 308 1.74561C309.798 1.74561 311.25 3.19598 311.25 4.97826Z"
        stroke="#8453E6"
        strokeWidth="1.5"
      />
      <path
        d="M65.5 28.874C65.5 32.4385 62.596 35.3393 59 35.3393C55.404 35.3393 52.5 32.4385 52.5 28.874C52.5 25.3094 55.404 22.4087 59 22.4087C62.596 22.4087 65.5 25.3094 65.5 28.874Z"
        stroke="#6ECEF7"
        strokeWidth="3"
      />
      <path
        d="M394.5 270.82C394.5 274.385 391.596 277.286 388 277.286C384.404 277.286 381.5 274.385 381.5 270.82C381.5 267.256 384.404 264.355 388 264.355C391.596 264.355 394.5 267.256 394.5 270.82Z"
        stroke="#8453E6"
        strokeWidth="3"
      />
      <path
        d="M473.25 187.185C473.25 188.967 471.798 190.417 470 190.417C468.202 190.417 466.75 188.967 466.75 187.185C466.75 185.403 468.202 183.952 470 183.952C471.798 183.952 473.25 185.403 473.25 187.185Z"
        stroke="#FF8255"
        strokeWidth="1.5"
      />
      <path
        d="M139.25 44.8049C139.25 46.5872 137.798 48.0376 136 48.0376C134.202 48.0376 132.75 46.5872 132.75 44.8049C132.75 43.0226 134.202 41.5723 136 41.5723C137.798 41.5723 139.25 43.0226 139.25 44.8049Z"
        stroke="#1CC0A5"
        strokeWidth="1.5"
      />
      <path
        d="M195 290.733C195 291.085 194.86 291.423 194.609 291.672C194.359 291.921 194.02 292.061 193.667 292.061H185.667L183 294.716V284.096C183 283.744 183.14 283.406 183.391 283.157C183.641 282.908 183.98 282.768 184.333 282.768H193.667C194.02 282.768 194.359 282.908 194.609 283.157C194.86 283.406 195 283.744 195 284.096V290.733Z"
        stroke="#25B5F3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62 146.362C62 146.714 61.8595 147.052 61.6095 147.301C61.3594 147.55 61.0203 147.69 60.6667 147.69H52.6667L50 150.345V139.725C50 139.372 50.1405 139.035 50.3905 138.786C50.6406 138.537 50.9797 138.397 51.3333 138.397H60.6667C61.0203 138.397 61.3594 138.537 61.6095 138.786C61.8595 139.035 62 139.372 62 139.725V146.362Z"
        stroke="#1CC0A5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 66.7094C39 67.0615 38.8595 67.3992 38.6095 67.6482C38.3594 67.8971 38.0203 68.037 37.6667 68.037H29.6667L27 70.6921V60.0717C27 59.7196 27.1405 59.3819 27.3905 59.133C27.6406 58.884 27.9797 58.7441 28.3333 58.7441H37.6667C38.0203 58.7441 38.3594 58.884 38.6095 59.133C38.8595 59.3819 39 59.7196 39 60.0717V66.7094Z"
        stroke="#FF8255"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M549 144.371C549 144.723 548.86 145.061 548.609 145.31C548.359 145.559 548.02 145.699 547.667 145.699H539.667L537 148.354V137.733C537 137.381 537.14 137.044 537.391 136.795C537.641 136.546 537.98 136.406 538.333 136.406H547.667C548.02 136.406 548.359 136.546 548.609 136.795C548.86 137.044 549 137.381 549 137.733V144.371Z"
        stroke="#8453E6"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M478 9.95651C478 10.3086 477.86 10.6463 477.609 10.8952C477.359 11.1442 477.02 11.2841 476.667 11.2841H468.667L466 13.9392V3.31876C466 2.96667 466.14 2.62901 466.391 2.38004C466.641 2.13108 466.98 1.99121 467.333 1.99121H476.667C477.02 1.99121 477.359 2.13108 477.609 2.38004C477.86 2.62901 478 2.96667 478 3.31876V9.95651Z"
        stroke="#1CC0A5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40 286.751V300.69"
        stroke="#1CC0A5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 293.72H47"
        stroke="#1CC0A5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M471.509 298.634L467.885 312.099"
        stroke="#25B5F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M462.935 303.562L476.458 307.17"
        stroke="#25B5F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M342 293.057V302.349"
        stroke="#1CC0A5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M337.333 297.703H346.667"
        stroke="#1CC0A5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M378 16.2627V25.5555"
        stroke="#25B5F3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M373.333 20.9092H382.667"
        stroke="#25B5F3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M525.785 23.0063L528.216 36.7339"
        stroke="#FF8255"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M520.107 31.0801L533.894 28.6595"
        stroke="#FF8255"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M217.117 23.9038L214.686 37.6313"
        stroke="#8453E6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M209.008 29.5571L222.795 31.9777"
        stroke="#8453E6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Confetti
